// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#name {
  color: white;
  font-weight: bold;
}
.name {
  border-right: solid 3px red;
  white-space: nowrap;
  overflow: hidden;
  font-size: 2rem;
  color: rgba(255, 255, 255, 0.7);
}

/* Animation */
.name {
  animation: animated-text 4s steps(29, end) 1s 1 normal both,
    animated-cursor 600ms steps(29, end) infinite;
}

/* text animation */

@keyframes animated-text {
  from {
    width: 0;
  }
  to {
    width: 24rem;
  }
}
.speciality {
  font-size: 5rem;
  color: red;
  line-height: 1;
}
.cvButton:link,
.cvButton:visited {
  width: fit-content;
  padding: 1rem 1rem;
  display: inline-block;
  font-weight: 600;
  color: black;
  line-height: 1;
  background: #fff;
  border-radius: 2rem;
  text-align: center;
  text-transform: uppercase;
  animation: all 0.5s;
}

.cvButton:hover {
  color: red;
  transform: translateY(-0.2rem);
  box-shadow: 0.1rem 0.5rem 1rem rgba(255, 255, 255, 0.1);
}
.cvButton:active {
  transform: translateY(-0.1rem);
  box-shadow: 0.05rem 0.25px 0.5rem rgba(255, 255, 255, 0.2);
}
.changeText {
  overflow: hidden;
  position: relative;
  height: 5.5rem;
  font-size: 5rem;
  color: red;
  position: relative;
  line-height: 1;
}
ul {
  padding: 0;
}

.flip2 {
  animation: flip2 6s cubic-bezier(0.23, 1, 0.32, 1.2) infinite;
}

@keyframes flip2 {
  0% {
    margin-top: -10rem;
  }
  5% {
    margin-top: -5rem;
  }
  50% {
    margin-top: -5rem;
  }
  55% {
    margin-top: 0px;
  }
  99.99% {
    margin-top: 0px;
  }
  100% {
    margin-top: -15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/page1/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE;iDAC+C;AACjD;;AAEA,mBAAmB;;AAEnB;EACE;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,uDAAuD;AACzD;AACA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["#name {\n  color: white;\n  font-weight: bold;\n}\n.name {\n  border-right: solid 3px red;\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 2rem;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Animation */\n.name {\n  animation: animated-text 4s steps(29, end) 1s 1 normal both,\n    animated-cursor 600ms steps(29, end) infinite;\n}\n\n/* text animation */\n\n@keyframes animated-text {\n  from {\n    width: 0;\n  }\n  to {\n    width: 24rem;\n  }\n}\n.speciality {\n  font-size: 5rem;\n  color: red;\n  line-height: 1;\n}\n.cvButton:link,\n.cvButton:visited {\n  width: fit-content;\n  padding: 1rem 1rem;\n  display: inline-block;\n  font-weight: 600;\n  color: black;\n  line-height: 1;\n  background: #fff;\n  border-radius: 2rem;\n  text-align: center;\n  text-transform: uppercase;\n  animation: all 0.5s;\n}\n\n.cvButton:hover {\n  color: red;\n  transform: translateY(-0.2rem);\n  box-shadow: 0.1rem 0.5rem 1rem rgba(255, 255, 255, 0.1);\n}\n.cvButton:active {\n  transform: translateY(-0.1rem);\n  box-shadow: 0.05rem 0.25px 0.5rem rgba(255, 255, 255, 0.2);\n}\n.changeText {\n  overflow: hidden;\n  position: relative;\n  height: 5.5rem;\n  font-size: 5rem;\n  color: red;\n  position: relative;\n  line-height: 1;\n}\nul {\n  padding: 0;\n}\n\n.flip2 {\n  animation: flip2 6s cubic-bezier(0.23, 1, 0.32, 1.2) infinite;\n}\n\n@keyframes flip2 {\n  0% {\n    margin-top: -10rem;\n  }\n  5% {\n    margin-top: -5rem;\n  }\n  50% {\n    margin-top: -5rem;\n  }\n  55% {\n    margin-top: 0px;\n  }\n  99.99% {\n    margin-top: 0px;\n  }\n  100% {\n    margin-top: -15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
